export const modalStyles = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.9)',
    zIndex: 20,
  },
  content: {
    backgroundColor: 'rgb(240,233,246)',
    margin: 'auto',
    maxWidth: '35rem',
    height: 'fit-content',
    padding: '1.5rem 0',
    textAlign: 'center',
    border: 'none',
    color: 'black',
    textShadow: '1px 0.5px rgba(0, 0, 0, 0.2)',
    zIndex: 20,
    minHeight: '14.75rem',
    maxHeight: '80vh',
    overflowY: 'scroll',
  },
};
